import React from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import PropTypes from 'prop-types';
import { callApp, getSchemeLink } from '@ifeng-fe/callapp';
import { WxLaunchApp } from 'ThreeTerminal_mobile_dynamic';
import styles from './index.css';

class OpenAppButton extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    callAppkHandle = (isSendCount = true, isJumpQQlink = false, isCallApp = true) => {
        const { content } = this.props;
        const downloads = content.isVideoShare
            ? {}
            : {
                  download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1523710506194',
                  downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8967',
              };
        const client = content.isVideoShare ? 'videoApp' : 'newsApp';

        if (isCallApp) {
            callApp({
                client,
                docType: 'phvideo', // videoshortimg
                pid: content._id,
                kind: 'inter_fxy14',
                download: downloads.download,
                downloadAd: downloads.downloadAd,
                isCopySchemeUrl: isJumpQQlink,
            });
        }
    };

    render() {
        const { content } = this.props;
        const schemeLink = getSchemeLink({
            docType: 'phvideo',
            pid: content._id,
            kind: 'share01',
        });

        return (
            <div onClick={this.callAppkHandle} className={styles.openAppButton}>
                打开APP阅读更多精彩内容
                {!content?.isVideoShare && (
                    <WxLaunchApp
                        launchType={'app'}
                        launchAppClick={this.callAppkHandle.bind(this, true, false, false)}
                        schemeLink={schemeLink}
                        launchAppFail={this.callAppkHandle.bind(this, false, true, true)}
                    />
                )}
            </div>
        );
    }
}

export default errorBoundary(OpenAppButton);
